import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const MaintenanceBanner = ({ onDisable }) => {
    const [disabling, setDisabling] = useState(false);

    const handleDisable = async () => {
        setDisabling(true);
        await onDisable();
        setDisabling(false);
    };

    return (
        <div className="fixed top-[64px] left-0 right-0 z-[60] bg-gradient-to-r from-orange-600 to-red-600 border-b-4 border-red-700 shadow-2xl">
            <div className="max-w-7xl mx-auto px-4 py-3">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center space-x-3">
                        <div className="bg-white/20 p-2 rounded-lg animate-pulse">
                            <AlertTriangle className="w-5 h-5 text-white" />
                        </div>
                        <div>
                            <p className="text-white font-bold text-sm sm:text-base">
                                🚨 Mode Maintenance Actif
                            </p>
                            <p className="text-white/80 text-xs">
                                Les utilisateurs ne peuvent pas accéder au site
                            </p>
                        </div>
                    </div>

                    <button
                        onClick={handleDisable}
                        disabled={disabling}
                        className="bg-white hover:bg-gray-100 text-red-600 font-bold px-4 py-2 rounded-lg transition-all flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <X className="w-4 h-4" />
                        <span className="hidden sm:inline">
                            {disabling ? 'Désactivation...' : 'Désactiver'}
                        </span>
                        <span className="sm:hidden">
                            {disabling ? '...' : 'Stop'}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MaintenanceBanner;